// AUTO-GENERATED by /app/scripts/sync-version.js — do NOT edit by hand.
// Single source of truth is /app/VERSION.
export const APP_VERSION = "V10.71";
export const APP_VERSION_SEMVER = "10.71.0";
